import BaseDatepicker from 'components/atoms/base-datepicker';
import BaseSwitch from 'components/atoms/base-switch';
import { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { addDays } from 'date-fns';

import s from './styles.module.scss';

interface IProps {
  onChangeDate: (date: Date | null) => void;
  expiresDate: Date | null;
}

export const ExpiredDatePicker = ({ onChangeDate, expiresDate }: IProps) => {
  const [switchValue, toggleSwitch] = useReducer(
    (v) => !v,
    Boolean(expiresDate),
  );
  const { t } = useTranslation();
  const minDate = addDays(new Date(), 1);

  const dateValue = expiresDate || undefined;

  useEffect(() => {
    if (!switchValue) onChangeDate(null);
  }, [switchValue]);

  return (
    <div className={s['controller-btns']}>
      <div className={s['controller-switch']}>
        <BaseSwitch
          value={switchValue}
          onChange={toggleSwitch}
          label={t('labels.expirationDate')}
        />
      </div>
      <BaseDatepicker
        minDate={minDate}
        onChange={onChangeDate}
        disabled={!switchValue}
        value={dateValue}
        className={s['controller-calendar']}
        placeholder="MM-dd-yyy"
      />
    </div>
  );
};
